/** @format */

import { AxiosError, AxiosResponse } from "axios";
import { API_ENDPOINTS } from "../../constants/api";
import { TBrandUpdateRequest } from "../../redux-modules/declarations/maps/brand";
import apiClient from "../../utils/apiClient";

export const apiBrandUpdate = (
  data: TBrandUpdateRequest,
): Promise<{ response?: AxiosResponse; error?: AxiosError }> =>
  apiClient
    .put(API_ENDPOINTS.BRAND_UPDATE.replace(":id", `${data.id}`), data)
    .then(response => ({ response }))
    .catch(error => ({ error }));
